<template>
  <el-container height="auto">
    <el-main>


        <el-form ref="form" :model="form"  :rules="rules" label-width="100px">

           <el-row >
              <el-col :span="11">
                <el-form-item label="姓名" prop="subjectname">
                  <el-input v-model="form.subjectname"></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2"></el-col>
              <el-col :span="11">
                <el-form-item label="电话" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="11">
                <el-form-item label="编号" prop="subjectnumber">
                  <el-input v-model="form.subjectnumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2"></el-col>
              <el-col :span="11">
              
              </el-col>
            </el-row>
  <el-row style="text-align:center">
    <el-col>
        <el-link @click="(isShowBasicInfo)?(isShowBasicInfo=false):(isShowBasicInfo=true)" 
        
  style="padding:8px;"
  :underline="false">完善基本信息</el-link>
  <i :class="(isShowBasicInfo)?'fa fa-angle-double-down':'fa fa-angle-double-right'"></i>
    </el-col>
  </el-row>

            <!-- <el-divider @click="(isShowBasicInfo)?(isShowBasicInfo=false):(isShowBasicInfo=true)" >
              <el-link :underline="false">完善基本信息</el-link>
              
            </el-divider> -->
<div v-show="isShowBasicInfo">
            <el-row >
              <el-col :span="11">
                <el-form-item label="姓名缩写" >
                  <el-input v-model="form.initials"></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2"></el-col>
              <el-col :span="11">
                <el-form-item label="身份证号码" >
                  <el-input v-model="form.personalid" @blur="parsePersonalID(form.personalid)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row >
              <el-col :span="11">

                <el-form-item label="性别">
                  <el-radio-group v-model="form.sex" size="medium">
                    <el-radio-button label="M">男</el-radio-button>
                    <el-radio-button label="F">女</el-radio-button>
                    <el-radio-button label="U">未知</el-radio-button>
                  </el-radio-group>
                </el-form-item>
               
              </el-col>
              <el-col class="line" :span="2"></el-col>
              <el-col :span="11">
                <el-form-item label="出生日期" >
                  <el-date-picker type="date" placeholder="选择日期" v-model="form.dob" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            

            
            <!-- <el-form-item label="标签" >
              
              <el-tag
                v-if="form.category ||'' !=''"
                :key="tag"
                v-for="tag in form.category.split(',')"
                closable
                :disable-transitions="false"
                @close="handleTagClose(tag)">
                {{tag}}
              </el-tag>
              
              <el-input
                v-if="tag.inputvisiable"
                v-model="tag.inputvalue"
                ref="saveTagInput"
                size="small"
                style="margin-left:8px;width:90px;"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              
              <el-button v-else icon="el-icon-plus" size="small" 
                  @click="showTagInput"
                  style="margin-left:8px;width:90px;"
              >增加标签</el-button>

              <div style="border:solid 1px #AABBCC;margin:5px;padding:5px;">
                <div><i>全部标签</i></div>
                <el-tag
                  :key="index"
                  type="info"
                  v-for="(tag,index) in tags"
                  :disable-transitions="false"
                  @click="handleTagTemplateClick(tag)"
                  style="cursor:pointer;"
                >
                  {{tag.tagname}} {{tag.num>0?tag.num:''}}
                </el-tag>
                <el-link v-if="this.tagminnum==1" style="color:gray" :underline="false" @click="showFilterTag(0)"><i>显示未分配标签</i></el-link>
                <el-link v-if="this.tagminnum!=1" style="color:gray" :underline="false" @click="showFilterTag(1)"><i>隐藏未分配标签</i></el-link>
              </div>
              
              
            </el-form-item> -->
            <el-form-item label="备注" >
                  <el-input type="textarea" v-model="form.comments"></el-input>
                </el-form-item>
            <!-- <el-divider></el-divider> -->
</div>
        
            <el-row style="text-align:center">
              <el-col :span="24">
                <el-button type="primary" @click="onSave">保存</el-button>
                <el-button type="danger" @click="delSubject"
                v-if="subjectid||'' != ''"
                >删除</el-button>
              </el-col>
            </el-row>
            
          </el-form>

       
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        subjectid: this.$route.query.id,
        form: {
          subjectname: '',
          initials: '',
          sex: '',
          dob: '',
          category:'',
          comments: '',
          personalid:'',
          phone:'',
          subjectnumber:'',
        },
        rules: {
          subjectname: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ]
        },
        tag:{
          inputvisiable:false,
          inputvalue:'',
        },
        isShowBasicInfo:false,
        tags:[],
        tagminnum:1,
        weixinuserid:this.$route.query.weixinuserid,
        weixinuserinfo:{},
      }
    },
    computed:{
      computedTags(){
        let arry = [];
        if(this.form.category){
          arry = this.form.category.split(",");
        }

        return arry;
      },
    },
    mounted(){
      if(this.subjectid ||'' != ''){
        this.getsubjectinfo();
        this.isShowBasicInfo = true;
      }
      else{
        this.getSubjectNumber();
      }

      if(this.weixinuserid ||'' != ''){
        this.getWeixinUserInfo();
      }

      //this.getTagList();
    },
    methods: {
      onSave(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
              if(this.subjectid || '' !=''){

                  this.$http.post("subject/edit",this.form).then((res) => { 
                    if(!res) return;
                    //提醒成功
                    this.$message({ type:'success', message:'编辑成功'})
                    //this.$router.push({path:'/subject/new',query:{id:res.data.info.subjectid}});
                    this.$router.push({ path: '/home/subject', query:{}})
                  });

                }else{
                  this.form.weixinuserid = this.weixinuserid;
                  this.$http.post("subject/new",this.form).then((res) => { 
                    if(!res) return;
                    
                    //提醒成功
                    this.$message({ type:'success', message:'创建成功'})
                    // this.form= {
                    //             subjectname: '',
                    //             initials: '',
                    //             sex: '',
                    //             dob: '',
                    //             category:'',
                    //             comments: '',
                    //             personalid:'',
                    //             phone:'',
                    //             subjectnumber:'',
                    //           }
                    // this.getSubjectNumber();
                    // this.weixinuserid = undefined;
                    // this.weixinuserinfo = {};
                  
                    // this.getTagList();

                    //跳转到编辑页面
                    //this.$router.push({path:'/subject/new',query:{id:res.data.info.subjectid}});
                    this.$router.push({ path: '/home/subject', query:{}})
                  });
              }

              

              
          }
          
        });
      },
      showTagInput(){
        this.tag.inputvisiable = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      appendTag(tagname){
        let arrycategory=[];
        if(this.form.category){
          arrycategory = this.form.category.split(','); 
          if(arrycategory.indexOf(tagname) !=-1){
            //已存在
            return false;
          }
        }
        arrycategory.push(tagname);
        this.form.category = arrycategory.join(",");
        return true;
      },
      handleInputConfirm(){
        
        let tagname = this.tag.inputvalue;
        if(tagname){
          if(this.appendTag(tagname)){
            this.tag.inputvisiable = false;
            this.tag.inputvalue = '';
          }
          
        }

      },
      handleTagClose(tag){
        let arrycategory = this.form.category.split(',');        
        arrycategory.splice(arrycategory.indexOf(tag), 1);
        this.form.category = arrycategory.join(",");
      },
      getsubjectinfo(){
        this.$http.get('subject/info',
        {
          params:{subjectid:this.subjectid}
        })
        .then((res) => { 
          this.form = Object.assign(this.form,res.data.info);
        });
      },
      getSubjectNumber(){
        this.$http.get('subject/getsubjectnumber',
        {})
        .then((res) => { 
          this.form.subjectnumber = res.data.subjectnumber;
        });
      },
      delSubject(){
        this.$confirm("确定要删除吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post("subject/delete",{subjectid:this.subjectid}).then((res) => { 
                if(!res) return;

                  this.$router.push({name:"home-subject"});
               
                });
            }, ()=>{});
      },
      getWeixinUserInfo(){
        this.$http.get('weixinuser/info',{params:{weixinuserid:this.weixinuserid}}).then((res)=>{
          if(!res) return;
          this.weixinuserinfo = res.data.info;
          if(this.subjectid || '' !=''){}
          else{
            //使用微信用户提供的信息，初始化病例
            this.form.subjectname = res.data.info.nickname;
          }
        })
      },
      
      getTagList(){
        this.$http.get('tag/list',{params:{tagtype:'SUBJECT',minnum:this.tagminnum}}).then((res)=>{
          if(!res) return;
          
          this.tags = this.refreshTotalTag(res.data.list);

        })
      },
      refreshTotalTag(totaltags){
        let list = [];
        let arryTag = this.form.category.split(",");
        totaltags.forEach(element => {
          if(arryTag.indexOf(element.tagname) !=-1){
            //不需要显示
          }else{
            list.push(element);
          }
        });
        return list;
      },
      showFilterTag(tagnum){
        this.tagminnum = tagnum;
        this.getTagList();
      },
      handleTagTemplateClick(tag){
        this.appendTag(tag.tagname)

      },


      parsePersonalID(iden){
        let personalidNum = iden.length;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        let age = 0;
        let sex = null;
  
        if (personalidNum === 18) {
          this.form.dob = iden.substring(6, 10) + '-' + iden.substring(10,12) + '-' + iden.substring(12,14);
          sex = iden.substring(16,17);

          age = myDate.getFullYear() - iden.substring(6, 10) - 1;
          if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

        }
        if (personalidNum === 15) {
          this.form.dob = iden.substring(6, 8) + '-' + iden.substring(8,10) + '-' + iden.substring(10,12);
          sex = iden.substring(13,14);

          age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
          if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
        }

        if(sex){
          if(sex%2 === 0){
            this.form.sex = "F"
          }
          else{
            this.form.sex = "M"
          }
        }

        // console.log(age);
        // this.age = age;
          
      },
      
    },
    watch:{
      computedTags(val){
        this.getTagList();
      },
      // form:{
      //   handler(val,oldVal){
      //     console.log('deep' + val.personalid + '--' + oldVal.personalid)
          
      //   },
      //   deep:true
      // },
    }
  }
</script>
<style scoped>
  .el-tag + .el-tag{
    margin-left:15px;
  }
</style>